export const generateToken = () => {
    const smartpayId = crypto.randomUUID();
    return smartpayId;
}